import { generateUrlWithParams } from "utils";
import api from "./api";


const getClientRoles = (queryParams = { page: 1, page_size: 100 }) => {
  return api.get(generateUrlWithParams("crm/client-roles/", queryParams));
};

export { getClientRoles };
